import React from 'react';
import styled from 'styled-components/macro';
import { colors } from '../../theme';
import { NavItems } from '../../data/HeaderData';
import { Link } from 'react-router-dom';
import defaultProfileImage from '../../assets/images/default-profile-new.png';

const NavIconWrapper = styled.span`
  vertical-align: -6px;
  margin-right: 10px;
`;

const NavBarWrapper = styled.div``;

const DropdownButton = styled.a`
  padding: 20px 15px;
  border: none;
  cursor: pointer;

  svg {
    transform: scale(2.5);
  }
  .profile-icon {
    width: 45px;
  }
`;

const UList = styled.ul`
  position: relative;
  display: inline-block;
  padding: 0px;

  .dropdown li {
    position: relative;
    display: inline-block;
  }

  .dropdown-content {
    display: none;
    position: absolute;
    background-color: ${colors.white};
    min-width: 180px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    top: 44px;
    left: auto;
    right: 0;
    margin-right: 0px;
  }

  .dropdown-content .list-item {
    width: 100%;
    display: block;
    cursor: pointer;
    border-bottom: 1px solid ${colors.lightversion};
    padding: 12px 16px;
  }

  .dropdown-content a {
    color: ${colors.primary.black90};
    text-decoration: none;
    display: block;
  }

  .dropdown-content .list-item:hover {
    background-color: ${colors.lightversion};
  }

  &:hover .dropdown-content {
    display: block;
    left: auto;
    right: 0;
    margin-right: 0px;
  }
`;

export const HeaderListItems = () => {
  return (
    <>
      <div className="left-nav"></div>

      <div className="right-nav">
        <UList className="dropdown">
          <DropdownButton>
            <img src={defaultProfileImage} className="profile-icon" />
          </DropdownButton>
          <div className="dropdown-content">
            {NavItems?.profile?.subMenu?.map((item, index) => (
              <li className="list-item" key={index}>
                <Link to={item?.link}>
                  <NavIconWrapper className="nav-icon-wrapper">{<item.icon />}</NavIconWrapper>
                  {item?.text}
                </Link>
              </li>
            ))}
          </div>
        </UList>
      </div>
    </>
  );
};

HeaderListItems.defaultProps = {};
